<template>
  <div ref="title" class="mb-3"
       style="font-weight: 700;font-size: 1.2rem; color: black;opacity:0;transition-duration: 300ms;transition-timing-function: ease-in-out">
    Alerts
  </div>

  <div @mouseover="stopInterval()" @mouseleave="startInterval()" class="cert-carousel" v-if="!showError"
       style="  overflow-y: hidden;">
    <div ref="carousel-content" v-if="alertList!=null"
         class="cert-carousel-content d-flex flex-column mx-0  cert-vertical" :class="fade"
         style="opacity: 0;transition-duration: 300ms;">
      <div v-for="(item,index) in alertList" :key="index" class="col-12 d-flex flex-row">
        <div class="cert-alert-vertical-indicator"></div>
        <cert-alert-card :ref="item.ref" :id="item.uid" :title="item.title" :date="item.datetime?.human"
                         :image="`${baseUrl}proxy/${horusBase64.stringToBase64URLSafe(item.images?.[0]?.url)}`" type="alerts"
                         :small="true" style="padding-left: 1rem"/>
      </div>
    </div>
    <cert-progress-indicator v-if="alertList==null"/>
  </div>
  <cert-color-box v-if="showError" title="Could not load alerts" icon="error_outline"/>
</template>

<script>

import CertColorBox from "@/views/cert/components/CertColorBox";
import CertProgressIndicator from "@/views/cert/components/CertProgressIndicator";
import CertAlertCard from './CertAlertCard.vue';
import api from '../../../api.js';
import horusBase64 from "@/components/horusBase64";

export default {
  name: "CertAlertCaroussel",
  computed: {
    horusBase64() {
      return horusBase64
    }
  },
  components: {
    CertAlertCard,
    CertColorBox,
    CertProgressIndicator,
  },
  data() {
    return {
      fade: "",
      interval: null,
      activeCount: 3,
      activeIndex: 0,
      alertList: [],
      showError: false,
      baseUrlCyber: process.env.VUE_APP_BASE_URL_CYBER,
      baseUrl: process.env.VUE_APP_BASE_URL,
    }
  },
  created() {
  },
  mounted() {
    this.loadAlerts();
    this.startInterval();
  },
  unmounted() {
    this.stopInterval();
  },
  methods: {
    stopInterval() {
      if (this.interval == null)
        return;
      clearInterval(this.interval);
      this.interval = null;
    },
    startInterval() {
      if (this.interval != null)
        return;

      this.interval = setInterval(() => {
        const elm = this.alertList.at(0);
        this.$refs["carousel-content"].style.transitionDuration = "200ms";
        this.$refs["carousel-content"].style.transform = `translateY(-${this.$refs[elm.ref].$el.clientHeight}px)`;

        setTimeout(() => {
          const elm = this.alertList.at(0);
          this.alertList.shift();
          this.alertList.push(elm);
          this.fade = "";
          let el = this.$refs["carousel-content"];
          if (el != null) el.style.transitionDuration = "0ms";
          el = this.$refs["carousel-content"];
          if (el != null) el.style.transform = `translateY(0px)`;
        }, 300);
      }, 4000);
    },
    processAlertResponse(alerts) {
      console.log("ALERTS:", alerts)
      let counter = 0;
      this.alertList = alerts.map(item => {
        // item.title = `${item.title.substring(0, 50)}...`;
        item.ref = `alert_${counter++}`;
        return item;
      });
      this.showError = false;

      setTimeout(() => {
        this.$refs["carousel-content"].style.height = `${(this.$refs[this.alertList[0].ref].$el.clientHeight * 4)}px`;
        this.$refs["carousel-content"].style.opacity = "1";
        this.$refs["title"].style.opacity = "0.6";
      }, 600);
    },

    loadAlerts() {
      this.$refs["carousel-content"].style.height = `230px`;
      const response = {
        "items": [
          {
            "uid": 404,
            "title": "Security Alert: Check Point SmartConsole Flaw Under Active Exploitation (CVE-2026-16232)",
            "teaser": "",
            "bodytext": "Check Point has released security updates to address three security vulnerabilities, including the critical zero-day&nbsp;CVE-2026-16232&nbsp;affecting the SmartConsole login process, which has been actively exploited and could allow unauthenticated attackers to gain full administrative access to vulnerable Security Management Server and Multi-Domain Security Management Server (MDS) environments. The update also addresses&nbsp;CVE-2026-62144&nbsp;and&nbsp;CVE-2026-62145&nbsp;affecting other Check Point management and security products.\r\nAffected Systems:\r\nCheck Point Security Management Server and Multi-Domain Security Management Server (MDS):&nbsp;Versions R77.30, R80, R80.10, R80.20, R80.30, R81, R81.10, R81.20, R82, and R82.10.\r\nSecurity Risks\r\nSuccessful exploitation could allow attackers to bypass SmartConsole authentication, gain full administrative access, and modify security policies and configurations on vulnerable management servers.&nbsp;\r\nRecommended Actions\r\nThe National Cyber Security Authority (NCSA) recommends users and system administrators to:&nbsp;\r\nApply the latest supported security updates for affected Check Point products as soon as possible to address the vulnerability.\r\nUpgrade to the following supported versions:\r\nCheck Point Security Management Server and Multi-Domain Security Management Server (MDS) versions:R81.20: Jumbo HotFix Accumulator Take 158 or newer releasesR82: Jumbo HotFix Accumulator Take 118 or newer releasesR82.10: Jumbo HotFix Accumulator Take 36 or newer releasesFor additional mitigation guidance, follow the recommended Gateway and Management security hardening practices outlined in&nbsp;Check Point’s Hardening Guide.Before applying updates, ensure that a current and verified backup is available and can be restored if needed.\r\nFor further information and support, please contact the National Cyber Security Authority (NCSA) by email to&nbsp;rwcsirt@ncsa.gov.rw&nbsp;or call us on&nbsp;9009.\r\nReferences\r\nCVE-2026-16232Check Point Security Advisory (CVE-2026-16232)Check Point Gateway and Management Hardening GuideCheck Point Patches Exploited SmartConsole Flaw Allowing Full Admin Access\r\n\r\n",
            "datetime": {
              "timestamp": 1785167768,
              "formatted": "2026-07-27 15:56",
              "human": "27 Jul 2026, 15:56"
            },
            "images": [
              {
                "url": "fileadmin/Cyber/images/Images_for_alerts/checkpoint-2.png",
                "title": "",
                "alt": ""
              }
            ]
          },
          {
            "uid": 406,
            "title": "Security Alert: Apple Security Updates - July 2026",
            "teaser": "",
            "bodytext": "Apple has released security updates to address multiple vulnerabilities affecting several Apple platforms, including iOS, iPadOS, macOS, watchOS, tvOS, and visionOS. The vulnerabilities could compromise the security and integrity of affected Apple devices.\r\nSecurity Risks\r\nSuccessful exploitation could enable attackers to compromise application security, expose sensitive information, cause system instability, or bypass certain security protections through malicious websites or applications.&nbsp;For the full list of security updates released by Apple, please refer to&nbsp;Apple security releases.&nbsp;\r\nRecommended Actions\r\nThe National Cyber Security Authority (NCSA) recommends users and system administrators to:\r\n1. Upgrade, as soon as possible, to the latest supported version of installed Apple software in order to continue receiving technical support and security patches.The following software versions are available for upgrade:\r\niOS 26.6 and iPadOS 26.6:&nbsp;iPhone 11 and later, iPad Pro 12.9-inch 3rd generation and later, iPad Pro 11-inch 1st generation and later, iPad Air 3rd generation and later, iPad 8th generation and later, and iPad mini 5th generation and later.macOS Tahoe 26.6:&nbsp;macOS TahoemacOS Sequoia 15.7.8:&nbsp;&nbsp;macOS SequoiamacOS Sonoma 14.8.8:&nbsp;macOS SonomatvOS 26.6:&nbsp;Apple TV HD and Apple TV 4K (all models)watchOS 26.6:&nbsp;Apple Watch Series 6 and latervisionOS 26.6:&nbsp;Apple Vision Pro (all models)Safari 26.6:&nbsp; macOS Sonoma and macOS Sequoia\r\n2. Enable background updates or automatic updates\r\n3. Before any update task, ensure you have backup for your data.&nbsp;For further information and support, please contact the National Cyber Security Authority (NCSA) by emailto&nbsp;rwcsirt@ncsa.gov.rw&nbsp;or call us on&nbsp;9009.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\r\nReferences\r\nhttps://support.apple.com/en-us/100100Apple fixes over 75 security issues with your iPhone and 150+ for Mac, update now\r\n\r\n",
            "datetime": {
              "timestamp": 1785167580,
              "formatted": "2026-07-27 15:53",
              "human": "27 Jul 2026, 15:53"
            },
            "images": [
              {
                "url": "fileadmin/Cyber/images/Images_for_advisories/14September2021.jpg",
                "title": "",
                "alt": ""
              }
            ]
          },
          {
            "uid": 403,
            "title": "Alert: Active Exploitation of Microsoft SharePoint On-Premises Vulnerability",
            "teaser": "",
            "bodytext": "Microsoft has reported active exploitation of a newly disclosed vulnerability (CVE-2026-50522) affecting Microsoft SharePoint Server (On-Premises). According to Microsoft and security researchers, threat actors are exploiting the vulnerability to compromise vulnerable SharePoint servers, enabling unauthorized access and execution of malicious code.\r\nAffected Systems:\r\nMicrosoft SharePoint Enterprise Server 2016 Versions prior to 16.0.5561.1001Microsoft SharePoint Server 2019 Versions prior to 16.0.10417.20175Microsoft SharePoint Server Subscription Edition Versions prior to 16.0.19725.20434\r\nSecurity Risks\r\nThe identified vulnerabilities allow attackers to bypass security controls, remotely execute code, and steal cryptographic materials, compromising both the SharePoint environment and integrated Microsoft services.\r\nRecommended Actions\r\nThe National Cyber Security Authority (NCSA) recommends users and system administrators to take the following actions to mitigate the active exploitation of these vulnerabilities:\r\nUpdate immediately to the latest supported version of Microsoft SharePoint Server to address the vulnerabilities and mitigate associated risks.Follow the guidance provided by Microsoft and implement the recommended mitigations to minimize the risk of exploitation.Ensure you have a recent backup that can be restored easily before applying updates or workarounds.\r\nFor further information and support, please contact the National Cyber Security Authority (NCSA) by email to&nbsp;rwcsirt@ncsa.gov.rw&nbsp;or call us on&nbsp;9009.References\r\nmsrc.microsoft.com/update-guide/vulnerability/CVE-2026-50522&nbsp;&nbsp;Fourth SharePoint Vulnerability Exploited in Past Month's Wave of Attacksmicrosoft-sharepoint-attack-new-exploit/\r\n\r\n",
            "datetime": {
              "timestamp": 1785135447,
              "formatted": "2026-07-27 06:57",
              "human": "27 Jul 2026, 06:57"
            },
            "images": [
              {
                "url": "fileadmin/user_upload/Sharepoint.png",
                "title": "",
                "alt": ""
              }
            ]
          },
          {
            "uid": 402,
            "title": "Security Alert: Zimbra Security Update – July 2026",
            "teaser": "",
            "bodytext": "Zimbra has released a security update addressing multiple critical vulnerabilities in SNMP monitoring, the Classic Web Client, and mail forwarding, EWS extension along with other components. These vulnerabilities could expose systems to compromise and unauthorized access.\r\nAffected Systems:\r\nThe following components are affected, but not limited to:\r\nZimbra Collaboration Suite (ZCS):&nbsp;SNMP monitoring, Classic Web Client, mail forwarding, and EWS extension in versions prior to 10.1.20.\r\nSecurity Risks\r\nIdentified vulnerabilities can be exploited by attackers to execute system commands, inject malicious scripts, bypass security controls, steal email data, or gain unauthorized access to affected systems.&nbsp;\r\nFor additional information on Zimbra security updates and available patches, please refer&nbsp;to the official Zimbra Product News.\r\nRecommended Actions\r\nThe National Cyber Security Authority (NCSA) recommends users and system administrators to:\r\n1. Update affected Zimbra Collaboration Suite (ZCS) installations as soon as possible to the latest supported security releases to address the vulnerabilities.\r\nUpgrade to the supported versions:\r\nZimbra Collaboration Suite (ZCS):&nbsp;Upgrade to version&nbsp;10.1.20 or above, to remediate vulnerabilities affecting SNMP monitoring, Classic Web Client, mail forwarding, EWS extension, and related components.\r\n2. Before applying updates, ensure that a current and verified backup is available and can be restored if needed.\r\n3. For additional details on patch installation and mitigation, refer to&nbsp;Zimbra’s official guidance.\r\nFor further information and support, please contact the National Cyber Security Authority (NCSA) by email to&nbsp;rwcsirt@ncsa.gov.rw&nbsp;or call us on&nbsp;9009.\r\nReferences\r\nPatch Release Update: Zimbra 10.1.20https://wiki.zimbra.com/wiki/Zimbra_Releases/10.1.0/patch_installationhttps://thehackernews.com/2026/07/zimbra-patches-critical-snmp-command.html\r\n\r\n",
            "datetime": {
              "timestamp": 1784704560,
              "formatted": "2026-07-22 07:16",
              "human": "22 Jul 2026, 07:16"
            },
            "images": [
              {
                "url": "fileadmin/Cyber/images/Images_for_alerts/19October2022.png",
                "title": "",
                "alt": ""
              }
            ]
          },
          {
            "uid": 401,
            "title": "Security Alert: Oracle Security Updates – July 2026",
            "teaser": "",
            "bodytext": "Oracle has released its July 2026 Critical Patch Update (CPU), delivering 1,449 security fixes that remediate 1,434 unique vulnerabilities across 334 products, including critical issues exploitable remotely with potential impact that can affect business operations and stability.\r\nAffected systems\r\nAffected products include, but are not limited to:\r\nOracle Database&nbsp;&nbsp;&nbsp;Oracle Financial Services ApplicationsOracle E-Business Suite&nbsp;&nbsp;&nbsp;Oracle Java SE&nbsp;&nbsp;&nbsp;&nbsp;Oracle MySQL&nbsp;&nbsp;Oracle Fusion Middleware\r\n\r\nSecurity Risks\r\nThe identified vulnerabilities could be exploited to run malicious code, gain unauthorized access, expose or modify sensitive data, and disrupt critical systems. Exploitation may result in operational downtime, financial losses, and reputational harm.\r\nFor the full list of security updates released by Oracle, please refer to&nbsp;Critical Patch Updates.\r\nRecommended Actions\r\nThe National Cyber Security Authority (NCSA) recommends the following actions:\r\n1. Upgrade as soon as possible to the latest supported version of installed software in order to continue receiving technical support and security patches.\r\n2. Ensure you have the latest backup that can be easily restored before applying any updates or patches.&nbsp;\r\nFor further information and support, please contact the National Cyber Security Authority (NCSA) by emailto&nbsp;rwcsirt@ncsa.gov.rw&nbsp;or call us on&nbsp;9009.\r\nReferences\r\nOracle Critical Patch Update Advisory - July 2026Oracle Critical Patch Updates, Security Alerts and BulletinsOracle Patches Over 1,400 Vulnerabilities With Quarterly Security Updates&nbsp;&nbsp;&nbsp;\r\n\r\n",
            "datetime": {
              "timestamp": 1784704320,
              "formatted": "2026-07-22 07:12",
              "human": "22 Jul 2026, 07:12"
            },
            "images": [
              {
                "url": "fileadmin/user_upload/Oracle-Alert_25April2023_.jpg",
                "title": "",
                "alt": ""
              }
            ]
          }]
      };
      this.processAlertResponse(response.items);
      api;
      // api
      // .get(`${process.env.VUE_APP_BASE_URL_CYBER}api/alerts`)
      // .then((response) => this.processAlertResponse(response.data?.items))
      // .catch((error) => {
      //   error;
      //   this.showError = true;
      // });
    },
  },

}
</script>

